var data = [{
    'label': 'tr',
    'value': '0',
}, {
    'label': 'en',
    'value': '1',
}, ];


export { data };